module.exports = __webpack_public_path__ + "static/media/avatar-03.5918e41e.svg";